@use "Styles/includes/variables";
@use "Styles/mixins";
@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";

:host {
    display: block;
    margin: 0 0 16px;

    @include mixins.desktop-and-up {
        margin: 48px 0 16px;
    }

    .comments {
        &__title {
            display: flex;
            align-items: center;
            margin: 0 0 16px;
            font-family: variables.$fontQuaternary;
            font-size: mixins.get-font-size(text-md);
            line-height: mixins.get-line-height(text-md);
            letter-spacing: -0.16px;
            color: mixins.get-color(text, primary);
            font-weight: 900;
        }

        .comments__list + .comments__title {
            margin-top: 16px;
        }

        &__login-card {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            padding: 24px;
            background-color: mixins.get-color(background, bg-gray-100);
            border-radius: 16px;

            @include mixins.desktop-and-up {
                flex-direction: row;
                justify-content: space-between;
                padding: 16px 24px;
            }

            vm-button {
                flex-shrink: 0;
            }
        }

        &__login-card-text {
            margin: 0;
            font-size: mixins.get-font-size(text-sm);
            line-height: mixins.get-line-height(text-sm);
            color: mixins.get-color(text, text-primary);
            text-align: center;

            strong {
                display: block;
            }

            @include mixins.desktop-and-up {
                text-align: left;

                strong {
                    display: inline;
                }
            }
        }

        &__login-card-sep {
            display: none;
            margin: 0 4px;

            @include mixins.desktop-and-up {
                display: inline;
            }
        }

        &__load-more {
            display: flex;
            justify-content: center;

            // Only reserve vertical space while a spinner is inside; the empty
            // element still exists so the IntersectionObserver has something to
            // attach to.
            &:not(:empty) {
                padding: 16px 0;
            }
        }
    }

    // Desktop composer renders inline above the list with a bottom margin.
    // Mobile composer is pinned to the bottom of the sheet's scroll viewport
    // (see the vm-bottom-sheet block below) — no margin needed there.
    vm-video-comment-composer {
        margin: 0 0 16px;
    }

    // Mobile sheet: composer sticks to the bottom of the body so the list
    // scrolls beneath it. `.comments` fills the body height (flex column,
    // wrapper grows) so the composer's natural position lands at the body's
    // bottom — sticky then keeps it pinned once the list overflows.
    vm-bottom-sheet {
        --vm-bottom-sheet-body-padding: 8px 16px calc(24px + env(safe-area-inset-bottom, 0));

        [slot="header"] {
            font-family: variables.$fontQuaternary;
        }

        .comments {
            display: flex;
            flex-direction: column;
            flex-grow: 1;

            &__wrapper {
                flex-grow: 1;
            }
        }

        vm-video-comment-composer {
            position: sticky;
            bottom: 24px;
            margin: 0;

            // Fade the comments behind the composer into the sheet background
            // so scrolled list items don't distract from the input area.
            &::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: 0%;
                z-index: -1;
                height: calc(100% + 24px);
                background: linear-gradient(to top, mixins.get-color(background, bg-white) 5%, transparent);
                pointer-events: none;
            }
        }
    }
}
